<template>
    <div class="content">
        <h1>BESTÄTIGUNG</h1>
        <div v-if="ShoppingCart.OrderDone && ShoppingCart && ShoppingCart.Products && ShoppingCart.Products.length">
            <p class="salutation">
                {{ salutation }},<br>
                Sie haben {{ orderProductText }} erfolgreich bestellt:
            </p>
            <div v-for="(item, index) in ShoppingCart.Products" :key="index">
                <p class="item">
                    {{ item.Name }} &nbsp;|&nbsp; {{ item.Price }} €&nbsp;
                </p>
                <div
                    v-for="(data, dataIndex) in item.Data"
                    v-if="data.FirstName"
                    :key="dataIndex"
                    class="item-data">
                    {{ data.FirstName }} {{ data.LastName }}<br>
                    {{ data.PlaceOfBirth }} -
                    {{ data.DayOfBirth }}.{{ data.MonthOfBirth }}.{{ data.YearOfBirth }} -
                    {{ data.HourOfBirth }}:{{ data.MinuteOfBirth }} -
                    {{ data.Gender }}
                </div>
            </div>
            <p class="amount" v-if="ShoppingCart.Products.length > 1">Gesamtbetrag &nbsp;|&nbsp; {{ ShoppingCart.Sum }} €</p>
            <p v-if="ShoppingCart.Customer.Remark !== ''">Ihre unverbindliche Anmerkung:</p>
            <p v-if="ShoppingCart.Customer.Remark !== ''" class="item-data">"{{ ShoppingCart.Customer.Remark }}"</p>
            <p class="customer-headline">Ihre persönlichen Daten:</p>
            <p class="customer-data">
                {{ ShoppingCart.Customer.Title }} {{ ShoppingCart.Customer.FirstName }} {{ ShoppingCart.Customer.LastName }}<br>
                {{ ShoppingCart.Customer.Street }} {{ ShoppingCart.Customer.StreetNumber }}<br>
                {{ ShoppingCart.Customer.ZipCode }} {{ ShoppingCart.Customer.City }}<br>
                {{ ShoppingCart.Customer.Email }}<br>
                {{ ShoppingCart.Customer.Phone.replace('PLUS', '+') }}
            </p>
            <p class="affirmation">
                Es wurde soeben eine Bestätigung inklusive Rechnung an {{ ShoppingCart.Customer.Email }} versendet.
            </p>
            <p class="affirmation">
                Vielen Dank für Ihren Einkauf.<br>
                Sollten Sie mit unseren Leistungen zufrieden sein, freuen wir uns über eine Weiterempfehlung.
            </p>
        </div>
        <div v-else>
            Es befinden sich entweder noch keine Artikel in Ihrem Warenkorb, oder Sie haben die Bestellung noch nicht abgesendet.
        </div>
    </div>
</template>

<script>
export default {
    name: 'confirmation',
    data() {
        return {
            ShoppingCart: null,
            salutation: '',
            orderProductText: ''
        };
    },
    methods: {
        /**
         * method for getting shoppingcart content
         * ...and setting relevant values
         */
        getShoppingCartContent() {
            let storedShoppingcart = localStorage.shoppingcart;

            if (storedShoppingcart) {
                this.ShoppingCart = JSON.parse(storedShoppingcart);
            } else {
                this.ShoppingCart = {};
            }

            if (this.ShoppingCart.Customer) {
                let r = '';
                if (this.ShoppingCart.Customer.Title.search('Frau') === -1) {
                    r = 'r';
                }
                this.salutation = 'Sehr geehrte' + r + ' ' + this.ShoppingCart.Customer.Title + ' ' + this.ShoppingCart.Customer.LastName;
            }

            if (this.ShoppingCart.Products) {
                if (this.ShoppingCart.Products.length > 1) {
                    this.orderProductText = 'folgende Artikel';
                } else {
                    this.orderProductText = 'folgenden Artikel';
                }

                this.ShoppingCart.Products.forEach(item => {
                    this.amount += parseInt(item.Price);
                });
            }

            if (this.ShoppingCart.OrderDone &&
                this.ShoppingCart &&
                this.ShoppingCart.Products &&
                this.ShoppingCart.Products.length
            ) {
                this.emitLogData('order', localStorage.shoppingcart);
            }

            this.$nextTick(() => {
                this.deleteShopingCartProduts();
            });
        },

        deleteShopingCartProduts() {
            let updatedShoppingCart = {
                'Products': [],
                'ProductsValid': false,
                'Sum': 0,
                'OrderDone': false
            };
            localStorage.shoppingcart = JSON.stringify(updatedShoppingCart);
            this.$emit('update-shoppingcart');
        },

        emitLogData(page, action) {
            if (page === 'order') {
                this.$emit(
                    'log-it',
                    '{"page": "' + page + '", "action": ' + action + '}'
                );
            } else {
                this.$emit(
                    'log-it',
                    '{"page": "' + page + '", "action": "' + action + '"}'
                );
            }
        }
    },
    created() {
        this.getShoppingCartContent();
    },
    mounted() {
        this.emitLogData('confirmation', 'visit');
    },
    beforeDestroy() {
        this.emitLogData('confirmation', 'leave');
    }
};
</script>

<style lang="scss" scoped>
    .salutation {
        line-height: 1em;
    }
    .item {
        font-weight: bold;
    }
    .item-data {
        line-height: 1em;
        margin: -18px 0 20px 0;
    }
    .amount {
        font-weight: bold;
    }
    .customer-headline {
        font-weight: bold;
    }
    .customer-data {
        margin-top: -12px;
        line-height: 1em;
    }
    .affirmation {
        line-height: 1em;
        margin-top: 15px;
    }
</style>
